import { injectable, inject } from "inversify";
import { IF360Validator } from "./F360Validator";
import "reflect-metadata";
import { DIMixins } from "@/core/@types/types";
import type { IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";

@injectable()
export default class TesteGeraisValidator implements IF360Validator {
  @inject(DIMixins.USER_PROFILE_STORAGE)
  userProfileMixin!: IUserProfileStorageMixin;

  handleValidation(): boolean {
    const isTestesGerais = this.userProfileMixin.handleGetUserProfile()
      ?.CodigoCliente
      ? this.userProfileMixin
          .handleGetUserProfile()
          ?.Grupo?.indexOf("TESTES GERAIS") !== -1
      : false;

    return isTestesGerais;
  }
}
